import { Button } from "@mui/material";
import { CommodityManagementSiteModel, CommodityManagementUserPermissions, MarketViewUserModel } from "../../../../Generated/Mark-It-View-Api";
import { StoneXGrid, StoneXRow } from "../../../StoneX";
import { StoneXAutocomplete, StoneXModal } from "../../../StoneXMui";
import { useEffect, useState } from "react";
import { MarkItViewApi } from "../../../../Apis/Apis";
import { ColDef, EditableCallbackParams, ValueGetterParams, ValueSetterParams } from "ag-grid-community";
import { EnumHelper } from "../../../../Helpers";
import { Close } from "@mui/icons-material";

interface UpdateSiteUsersProps {
  open: boolean;
  site?: CommodityManagementSiteModel;
  onClose: () => void;
}

export function UpdateSiteUsersModal(props: UpdateSiteUsersProps) {
  const { open, site, onClose } = props;

  const [users, setUsers] = useState<Record<string, MarketViewUserModel>>({});

  useEffect(() => {
    MarkItViewApi.listMarketViewUsers(null).then((res) => {
      const userArray = res.data.rows ?? [];
      const userDict: Record<string, MarketViewUserModel> = {};
      userArray.forEach(user => {
        if (user.marketViewUserGuid) {
          userDict[user.marketViewUserGuid] = user;
        }
      });
      setUsers(userDict);
    });
  }, []);

  function addUserToSite() {
  }

  function save() {
  }

  const permissionKeys = Object.values(CommodityManagementUserPermissions);

  const columns: ColDef[] = [
      {
        headerName: 'User',
        valueGetter: (params: ValueGetterParams) => users[params.data.marketViewUserGuid]?.displayName ?? 'Unknown User',
        checkboxSelection: false,
        editable: false,
        minWidth: 80,
        flex: 1,
      },
      {
        headerName: 'Company',
        valueGetter: (params: ValueGetterParams) => users[params.data.marketViewUserGuid]?.company?.name,
        minWidth: 80,
        flex: 1,
      },
      {
        headerName: 'Site Manager',
        field: 'isSiteManager',
        width: 130,
        cellRenderer: 'agCheckboxCellRenderer',
        cellEditor: 'agCheckboxCellEditor',
        valueGetter: (params: ValueGetterParams) => users[params.data.marketViewUserGuid]?.isAdministrator || params.data.isSiteManager,
        valueSetter: (params: ValueSetterParams) => {
          const checked = params.newValue;
          params.data.isSiteManager = checked;
          // updateSiteAccess(params.data.siteGuid, { 
          //   isSiteManager: checked, 
          //   permissions: checked 
          //     ? Object.values(CommodityManagementUserPermissions) 
          //     : []
          // });
          return true;
        },
        editable: (params: EditableCallbackParams) => !users[params.data.marketViewUserGuid]?.isAdministrator, // Admins always have site manager permissions
        },
        ...permissionKeys.map((perm: string) => ({
            headerName: EnumHelper.enumToString(perm).replace("Manage", ""),
            field: perm,
            minWidth: 80,
            flex: 1,
            cellRenderer: 'agCheckboxCellRenderer',
            cellEditor: 'agCheckboxCellEditor',
            editable: (params: EditableCallbackParams) => !params.data.isSiteManager && !users[params.data.marketViewUserGuid]?.isAdministrator,
            valueGetter: (params: any) => users[params.data.marketViewUserGuid]?.isAdministrator || params.data.isSiteManager || params.data.permissions?.includes(perm),
            valueSetter: (params: any) => {
              const checked = params.newValue;
              const permissions = params.data.permissions || [];
              if (checked && !permissions.includes(perm)) {
                params.data.permissions = [...permissions, perm];
              } else if (!checked && permissions.includes(perm)) {
                params.data.permissions = permissions.filter((p: string) => p !== perm);
              }
              return true;
            },
        })),
        {
          headerName: '',
          field: 'remove',
          width: 50,
          cellRenderer: (params: any) => {
            return <Close />
          },
          editable: false,
          sortable: false,
          filter: false,
          suppressMenu: true,
        }
    ];

  return (
    <StoneXModal header="Update Site Users" open={open} onClose={onClose} width='100%'>
      <StoneXRow>
        <StoneXAutocomplete 
          options={Object.values(users)} 
          getOptionLabel={x => x.displayName} 
          label="Add User"
          onUpdate={() => {}} />
      </StoneXRow>
      <StoneXRow marginDirection='topAndBottom'>
        <div style={{ width: '100%' }}>
          <StoneXGrid
            rows={site?.userSiteAccesses ?? []}
            columns={columns}
            getRowId={params => params.data.marketViewUserGuid}
            hideGridOptions
            gridOptions={{
              suppressMultiRangeSelection: true,
              stopEditingWhenCellsLoseFocus: true,
            }}
          />
        </div>
      </StoneXRow>
      <StoneXRow justify="end">
        <Button variant="outlined" onClick={onClose}>Cancel</Button>
        <Button onClick={save}>Save Users</Button>
      </StoneXRow>
    </StoneXModal>
  );
}